import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, useTheme, Box, Typography } from '@ublend-npm/aulaui-core';

interface SpacesShowArchivedSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const SpacesShowArchivedSwitch: React.FC<SpacesShowArchivedSwitchProps> = ({
  checked,
  onChange,
}) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      height={48}
      sx={{ whiteSpace: 'nowrap', ml: 0 }}
    >
      <Typography
        tabIndex={0}
        sx={{
          fontSize: '1rem',
          fontWeight: '400',
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.common.white
              : theme.palette.text.primary,
        }}
      >
        Show archived
      </Typography>
      <Checkbox
        kind="switch"
        label=""
        checked={checked}
        onChange={() => onChange(!checked)}
        inputProps={{
          tabIndex: 0,
          'aria-label': 'Show archived',
        }}
        sx={{
          color: theme.palette.primary.main,
          m: 0,
          whiteSpace: 'nowrap',
          height: 48,
          display: 'flex',
          alignItems: 'center',
          '& .MuiFormControlLabel-label': {
            fontSize: theme.typography.fontSize,
            fontWeight: 400,
            color:
              theme.palette.mode === 'dark'
                ? theme.palette.common.white
                : theme.palette.text.primary,
          },
          // '&:hover': {
          //   outline: `2px solid ${theme.palette.primary.main}`,
          // },
        }}
      />
    </Box>
  );
};

SpacesShowArchivedSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SpacesShowArchivedSwitch;
